import RotateIn from './rotate-in'
import RotateInDownLeft from './rotate-in-down-left'
import RotateInDownRight from './rotate-in-down-right'
import RotateInUpRight from './rotate-in-up-right'
import RotateInUpLeft from './rotate-in-up-left'

export default {
  RotateIn,
  RotateInDownLeft,
  RotateInDownRight,
  RotateInUpLeft,
  RotateInUpRight
}



// WEBPACK FOOTER //
// ./src/libs/animated-vue/transitions/rotating-entrances/index.js